function isMobile() {
    return window.matchMedia('(max-width: 1023px)').matches
}

function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

function scrollToElement(element, offset = 0) {
    const rect = element.getBoundingClientRect();
    const scrollPosition = window.scrollY + rect.top - offset;

    window.scrollTo({
        top: scrollPosition,
        behavior: 'smooth', // Optional: makes the scroll smooth
    });
}


document.querySelectorAll('.input-container.select-input').forEach(function (container) {
    container.addEventListener('click', function (event) {
        const selectElement = container.querySelector('select');

        // Verifica se il clic non è avvenuto direttamente sul <select> o su un suo discendente
        if (!selectElement.contains(event.target)) {
            selectElement.click();  // Simula un clic sul <select>
        }
    });
});

class SliderComponent extends HTMLElement {
    constructor() {
        super();

        this.prevScrollOffset = 0;
    }

    connectedCallback() {
        this.initScrollSnapPagination();
        if (this.hasAttribute('data-infinite-loop')) {
            this.enableInfiniteLoop();
        }
        this.initArrowScroll();
    }

    initScrollSnapPagination() {
        const container = this.querySelector('.slider-component__slides-wrapper');
        const slides = Array.from(this.querySelectorAll('.slider-component__slide'));

        if (!container || slides.length === 0) {
            console.error("Invalid selectors or missing elements");
            return;
        }

        // Create and append the pagination component
        this.createPaginationDots(slides.length);

        // Call unified scroll handler
        this.handleScroll(container, slides, this.hasAttribute('data-infinite-loop'));
    }

    createPaginationDots(slideCount) {
        let pagination = this.querySelector('.slider-component__pagination');
        if (!pagination) {
            pagination = document.createElement('div');
            pagination.classList.add('slider-component__pagination');

            const paginationContainer = document.createElement('div');
            paginationContainer.classList.add('slider-component__pagination__container');
            pagination.appendChild(paginationContainer);

            this.querySelector('.slider-component__slides').appendChild(pagination);
        }

        const paginationContainer = pagination.querySelector('.slider-component__pagination__container');
        paginationContainer.innerHTML = ''; // Clear any existing dots

        for (let i = 0; i < slideCount; i++) {
            const dot = document.createElement('div');
            dot.classList.add('slider-component__pagination__dot');
            if (i === 0) dot.classList.add('active');
            paginationContainer.appendChild(dot);
        }
    }

    enableInfiniteLoop() {
        const container = this.querySelector('.slider-component__slides-wrapper');
        const slides = Array.from(this.querySelectorAll('.slider-component__slide'));

        if (!container || slides.length === 0) {
            console.error("Invalid selectors or missing elements");
            return;
        }

        // Create initial duplicates
        slides.forEach(slide => {
            const clone = slide.cloneNode(true);
            container.appendChild(clone);
        });
        this.handleScroll(container, slides);
    }

    handleScroll(container, slides, createDuplicates) {

        container.scrollLeft = 0;
        this.prevScrollOffset = 0;

        let duplicationCount = 0;
        let scrollTimeout;

        container.addEventListener('scroll', () => {
            clearTimeout(scrollTimeout);
            const slideWidth = slides[0].offsetWidth;

            scrollTimeout = setTimeout(() => {
                const currentScroll = container.scrollLeft;
                const totalSlides = slides.length;
                const duplicatedSlides = duplicationCount * totalSlides;

                const isScrollingForward = currentScroll > this.prevScrollOffset;
                const currentIndex = Math.floor(currentScroll / slideWidth) - duplicatedSlides;

                if (createDuplicates) {
                    if (isScrollingForward && currentIndex >= totalSlides - 3) {
                        slides.forEach(slide => {
                            const clone = slide.cloneNode(true);
                            container.appendChild(clone);
                        });
                        duplicationCount++;
                    }
                }

                const dots = this.querySelectorAll('.slider-component__pagination__dot');
                const relativeIndex = currentIndex % totalSlides;

                dots.forEach((dot, index) => {
                    if (index === relativeIndex) {
                        dot.classList.add('active');
                    } else {
                        dot.classList.remove('active');
                    }
                });

                this.prevScrollOffset = currentScroll;
            }, 150);
        });
    }

    initArrowScroll() {
        const container = this.querySelector('.slider-component__slides-wrapper');
        const prevArrow = this.querySelector('.slider-component__prev-arrow');
        const nextArrow = this.querySelector('.slider-component__next-arrow');

        prevArrow?.addEventListener('click', () => {
            const slideWidth = container.querySelector('.slider-component__slide').offsetWidth;
            container.scrollBy({
                left: -slideWidth,
                behavior: 'smooth'
            });
        });

        nextArrow?.addEventListener('click', () => {
            const slideWidth = container.querySelector('.slider-component__slide').offsetWidth;
            container.scrollBy({
                left: slideWidth,
                behavior: 'smooth'
            });
        });
    }
}

customElements.define('slider-component', SliderComponent);

//car details
document.querySelectorAll('.car-details__highlight--head').forEach(detail => {
    detail.addEventListener('click', () => {
        detail.classList.toggle('active')
    })
})
//faqs
document.querySelectorAll('.faq__highlight--head').forEach(detail => {
    detail.addEventListener('click', () => {
        detail.classList.toggle('active')
    })
})

//append whatsapp widget
if (!document.querySelector('.car-cta')) {
    const whatsappWidget = document.createElement('whatsapp-widget')
    document.body.appendChild(whatsappWidget)
}


class RangeSlider extends HTMLElement {
    constructor() {
        super();
        this.container = this;
        if (!this.container) return;

        this.rangeMin = this.container.querySelector('.range-min');
        this.rangeMax = this.container.querySelector('.range-max');
        this.minPrice = this.container.querySelector('.min-value');
        this.maxPrice = this.container.querySelector('.max-value');
        this.sliderTrack = this.container.querySelector('.slider-track');

        // Extract unit and step from the `data-` attributes
        this.unit = this.getAttribute('data-unit') || '';
        this.key = this.getAttribute('data-meta') || '';
        this.step = parseInt(this.rangeMin.getAttribute('step')) || 100; // Default step

        this.carsListing = this.closest('cars-listing')

        this.init();
    }

    init() {
        if (this.rangeMin && this.rangeMax) {
            this.rangeMin.addEventListener('input', this.updateSlider.bind(this));
            this.rangeMax.addEventListener('input', this.updateSlider.bind(this));
            this.updateSlider(); // Initialize slider values and styles
        }
    }

    updateSlider() {
        const minValue = parseInt(this.rangeMin.value, 10);
        const maxValue = parseInt(this.rangeMax.value, 10);

        // Ensure minValue doesn't exceed maxValue minus the step
        if (minValue > maxValue - this.step) {
            if (document.activeElement === this.rangeMin) {
                this.rangeMin.value = maxValue - this.step;
            } else {
                this.rangeMax.value = minValue + this.step;
            }
        }

        // Format displayed values
        const formatValue = (value, unit) => {
            if (unit === '€') {
                return ` ${unit} ${new Intl.NumberFormat('it-IT', {maximumFractionDigits: 0}).format(value)}`;
            } else if (unit === 'km') {
                return `${new Intl.NumberFormat('it-IT', {maximumFractionDigits: 0}).format(value)} ${unit}`;
            }
            return `${value}`;
        };

        this.minPrice.textContent = formatValue(this.rangeMin.value, this.unit);
        this.maxPrice.textContent = formatValue(this.rangeMax.value, this.unit);

        // Calculate percentages
        const min = parseInt(this.rangeMin.min, 10);
        const max = parseInt(this.rangeMax.max, 10);

        let percentMin = ((minValue - min) / (max - min)) * 100;
        let percentMax = ((maxValue - min) / (max - min)) * 100;

        // Apply adjustment factor only after 44%
        /*
        const adjustmentFactor = !isMobile() && this.closest('.hero') ? 0 : 0.03; // 3% adjustment

        if (percentMin > 44) {
            percentMin -= adjustmentFactor * 100;
        }

        if (percentMin > 56) {
            percentMin -= ((adjustmentFactor / 2) + 0.02) * 100; // Add extra adjustment after 58%
        }

        if (percentMax < 44) {
            percentMax += adjustmentFactor * 100;
        }

        if (percentMax < 56) {
            percentMax += ((adjustmentFactor / 2) + 0.02) * 100; // Add extra adjustment after 58%
        }*/

        // Update slider track
        this.sliderTrack.style.left = `${percentMin}%`;
        this.sliderTrack.style.right = `${100 - percentMax}%`;
    }

    createDistributionBars() {

        const that = this

        function extractValue(value) {
            if (that.key === 'prezzo' || that.key === 'chilometraggio') {
                return Number(value.replaceAll('.', '').replaceAll(',', '.'));
            } else if (that.key === 'anno') {
                return Number(value.split('/')[1]);
            }
            return value
        }

        const productData = this.carsListing.allCarsData

        if (productData) {
            const container = this.querySelector('.slider-bars-container');
            container.innerHTML = ''; // Clear existing bars if any

            // Assuming `productData` is an array of products with `price` attribute
            const maxValue = productData.reduce((max, p) => extractValue(p[this.key]) > max ? extractValue(p[this.key]) : max, 0);
            const minValue = productData.reduce((min, p) => extractValue(p[this.key]) < min ? extractValue(p[this.key]) : min, Infinity);
            const range = maxValue - minValue;
            const binSize = range / 15; // example: divide the range into 10 bins

            let bins = new Array(15).fill(0);

            // Count products in each bin
            productData.forEach(p => {
                const binIndex = Math.floor((extractValue(p[this.key]) - minValue) / binSize);
                if (binIndex >= bins.length) {  // Prevent binIndex from exceeding the bins array length
                    bins[bins.length - 1] += 1; // Add to the last bin
                } else {
                    bins[binIndex] += 1;
                }
            });

            const maxCount = Math.max(...bins);
            const minHeightPercent = 50

            // Create and append bars
            bins.forEach(count => {
                const bar = document.createElement('div');
                const percentage = (count / maxCount) * 100
                bar.style.height = `${percentage > 0 ? Math.max(percentage, minHeightPercent) : percentage}%`;// Height relative to max count
                bar.classList.add('range-distribution-bar');
                container.appendChild(bar);
            });
        }
    }


}

// Register the custom element
customElements.define('range-slider', RangeSlider);

//checkboxes

document.addEventListener('DOMContentLoaded', () => {
    const checkboxContainers = document.querySelectorAll('.filters__checkbox-container');

    checkboxContainers.forEach(container => {
        const header = container.closest('.filters__field').querySelector('.filters__checkbox-header');
        const group = container.querySelector('.filters__checkbox-group');
        const icon = container.closest('.filters__field').querySelector('.filters__checkbox-icon');

        header.addEventListener('click', () => {
            // Toggle visibility
            const isVisible = group.style.display === 'flex';
            group.style.display = isVisible ? 'none' : 'flex';

            // Optional: Rotate arrow icon
            if (icon) {
                icon.style.transform = isVisible ? 'rotate(0deg)' : 'rotate(90deg) translateY(15px)';
            }
        });
    });
});

//home hero filter
document.addEventListener('DOMContentLoaded', () => {
    const marchioSelect = document.getElementById('marchio');

    /* // Fetch Marchio terms
     fetch(`${window.location.origin}/wp-json/car-manager/v1/terms?taxonomy=marchio`)
         .then((response) => response.json())
         .then((data) => {
             if (Array.isArray(data)) {
                 // Populate the dropdown with fetched terms
                 data.forEach((term) => {
                     const option = document.createElement('option');
                     option.value = term.slug;
                     option.textContent = term.name;
                     marchioSelect?.appendChild(option);
                 });
             } else {
                 console.error('Failed to fetch marchio terms:', data);
             }
         })
         .catch((error) => {
             console.error('Error fetching marchio terms:', error);
         });*/

    marchioSelect?.addEventListener('change', function () {
        const selectedMarchio = this.value;
        const modelloSelect = document.getElementById('modello');
        // Disable the modello dropdown while loading
        modelloSelect.disabled = true;

        if (selectedMarchio) {
            modelloSelect.innerHTML = '<option value="" disabled selected>Caricamento...</option>';
            // Fetch Modello terms based on the selected Marchio
            fetch(`${window.location.origin}/wp-json/car-manager/v1/terms?taxonomy=modello&marchio=${selectedMarchio}`)
                .then((response) => response.json())
                .then((data) => {
                    if (Array.isArray(data)) {
                        modelloSelect.innerHTML = '<option value="" disabled selected>Modello: Tutti</option>';
                        data.forEach((term) => {
                            const option = document.createElement('option');
                            option.value = term.slug;
                            option.textContent = term.name;
                            modelloSelect.appendChild(option);
                        });
                        modelloSelect.disabled = false;
                    } else {
                        modelloSelect.innerHTML = '<option value="" disabled>No Modelli Available</option>';
                    }
                })
                .catch((error) => {
                    console.error('Error fetching modello terms:', error);
                    modelloSelect.innerHTML = '<option value="" disabled>Error loading Modelli</option>';
                });
        }

    });
});

class AVFilters extends HTMLElement {
    constructor() {
        super();

        this.openOverlayaction = this.querySelector('.filters__action button')
        this.overlay = this.querySelector('.filters__overlay')
        this.closeOverlayAction = this.overlay.querySelector('.filters__close')

        this.openOverlayaction.addEventListener('click', () => {
            this.toggleOverlay()
        })
        this.closeOverlayAction.addEventListener('click', () => {
            this.toggleOverlay()
        })
    }

    toggleOverlay() {
        this.overlay.classList.toggle('open')
    }
}

// Register the custom element
customElements.define('av-filters', AVFilters);

//Booking modal
document.addEventListener('DOMContentLoaded', () => {
    const prenotalaTriggers = document.querySelectorAll('.button[data-prenotala]');
    // Open Modal
    prenotalaTriggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
            document.querySelector('booking-modal#prenotala-modal').dispatchEvent(new Event('open'));
        });
    });

    const testDriveTriggers = document.querySelectorAll('.button[data-test-drive]');
    // Open Modal
    testDriveTriggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
            document.querySelector('booking-modal#test-drive-modal').dispatchEvent(new Event('open'));
        });
    });

    const carInfoTriggers = document.querySelectorAll('.button[data-car-info]');
    // Open Modal
    carInfoTriggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
            document.querySelector('booking-modal#car-info-modal').dispatchEvent(new Event('open'));
        });
    });
});

class BookingModal extends HTMLElement {
    constructor() {
        super();
        const subtitle = this.getAttribute('subtitle');
        const match = subtitle.match(/\/\/(.*?)\/\//);

        this.carName = ''
        if (match && match[1]) {
            this.carName = match[1]
        }

        let emailButtonId
        let whatsappButtonId
        switch (this.id) {
            case 'prenotala-modal':
                emailButtonId = 'prenotala-request-email'
                whatsappButtonId = 'prenotala-request-whatsapp'
                break
            case 'test-drive-modal':
                emailButtonId = 'test-drive-request-email'
                whatsappButtonId = 'test-drive-request-whatsapp'
                break
            case 'car-info-modal':
                emailButtonId = 'car-info-request-call'
                whatsappButtonId = 'car-info-request-whatsapp'
                break
        }

        // Define the modal's structure
        this.innerHTML = `
            <div class="booking-modal" style="display: none">
                <div class="booking-modal__overlay"></div>
                <div class="booking-modal__content">
                    <div class="title-with-text booking-modal__header">
                        <div class="title-with-text__container">
                            <div class="title-with-text__title heading-2"></div>
                            <div class="title-with-text__text text-large"></div>
                        </div>
                    </div>
                    <div class="booking-modal__form">
                        <!-- Form Fields -->
                        ${this.id === 'car-info-modal' ? '' : this.generateFormFields()}
                    </div>
                    ${this.id === 'car-info-modal' ? '' : `<div class="booking-modal__disclaimer text-small">
                        Questa prenotazione non garantisce che il veicolo sia disponibile né che abbiate priorità
                        sull'acquisto. Sarete contattati al più presto per discutere i dettagli dell'auto e della vostra visita.
                    </div>`}
                    <div class="booking-modal__actions">
                        <button id="${emailButtonId}" class="button-large button button-primary button-with-icon button-with-icon-right booking-modal__action email-action">${this.id === 'car-info-modal' ? `Chiamaci ora` : 'Invia Richiesta'}</button>
                        <button id="${whatsappButtonId}" class="button-large button button-primary button-with-icon button-with-icon-right booking-modal__action">${this.id === 'car-info-modal' ? `Scrivici su Whatsapp` : 'Invia con WhatsApp'}</button>
                        <button class="button-large button button-secondary button-with-icon button-with-icon-right booking-modal__action" id="cancel">Annulla</button>
                    </div>
                </div>
            </div>
        `;

        // Initialize form fields check and button disabling
        this.updateActionButtons();
    }

    connectedCallback() {
        this.querySelector('.title-with-text__title').innerHTML = this.getAttribute('title') || 'Prenota la Tua Auto';
        this.querySelector('.title-with-text__text').innerHTML = this.getAttribute('subtitle').replace('//', `<strong>`).replace('//', `</strong>`) || 'Inserisci i tuoi dati per inviare una richiesta di prenotazione.';

        this.modal = this.querySelector('.booking-modal');
        const cancelButton = this.querySelector('#cancel');
        const overlay = this.querySelector('.booking-modal__overlay');

        // Add open modal listener
        this.addEventListener('open', () => {
            this.modal.style.display = 'flex';
        });

        // Close modal
        cancelButton.addEventListener('click', () => {
            this.modal.style.display = 'none';
        });
        overlay.addEventListener('click', () => {
            this.modal.style.display = 'none';
        });

// Add event listeners to input fields for real-time validation
        this.querySelectorAll('input[required], textarea[required]').forEach(input => {
            input.addEventListener('input', () => this.updateActionButtons());
        });

        // Modify the Email button click event handler
        this.querySelector('button.email-action[id*=request]').addEventListener('click', () => {
            if (this.areFieldsValid()) {
                if (this.id === 'car-info-modal') {
                    window.open(`tel:+39049775939`, '_blank');
                } else {
                    const fields = this.collectFormData();
                    const message = this.generateRequestMessage(fields);

                    this.sendEmail(message, fields);
                }
                this.modal.style.display = 'none';
            } else {
                alert('Per favore, compila i campi richiesti.');
                this.highlightInvalidFields()
            }
        });

        // WhatsApp handler
        this.querySelector('button[id*=request-whatsapp]').addEventListener('click', () => {
            if (this.areFieldsValid() || this.id === 'car-info-modal') {

                const fields = this.collectFormData();
                let whatsappMessage = this.generateRequestMessage(fields);

                this.sendEmail(whatsappMessage, fields, true);

                const whatsappURL = `https://api.whatsapp.com/send?phone=393517220182&text=${encodeURIComponent(whatsappMessage)}`;
                window.open(whatsappURL, '_blank');

                //this.modal.style.display = 'none';
            } else {
                alert('Per favore, compila i campi richiesti.');
                this.highlightInvalidFields()
            }
        });
    }

    sendEmail(message, fields, hidden = false) {

        let requestType

        switch (this.id) {
            case 'prenotala-modal':
                requestType = 'Prenotazione'
                break
            case 'test-drive-modal':
                requestType = 'Test Drive'
                break
            case 'car-info-modal':
                requestType = 'Richiesta Disponibilità'
                break
        }

        const formData = new FormData();
        formData.append('message', message);

        fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            body: new URLSearchParams({
                'action': 'send_email',
                'message': message,
                'subject': `${hidden ? 'Whatsapp / ' : ''}${requestType} | ${this.carName}`,
                'from': `${fields.nome} ${fields.cognome} <${fields.email}>`,
                'car': this.carName,
                'request_type': requestType
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
            .then(response => response.json())
            .then(data => {
                if (!hidden) {
                    alert(data.message); // Display the server response message
                    this.modal.style.display = 'none';
                }
            })
            .catch(error => console.error('Error:', error));
    }

    updateActionButtons() {
        const isFormValid = this.areFieldsValid();
        //this.querySelector('button.email-action[id*=request]').disabled = !isFormValid;
    }

    areFieldsValid() {
        const fields = this.querySelectorAll('input[required], textarea[required]');
        return Array.from(fields).every(field => field.value.trim() !== '');
    }

    highlightInvalidFields() {
        // Remove existing highlights
        this.querySelectorAll('.invalid-input').forEach(field => {
            const fieldContainer = field.closest('.input-container')
            fieldContainer.classList.remove('invalid-input');
        });

        // Add highlight to invalid fields
        this.querySelectorAll('input[required], textarea[required]').forEach(field => {
            if (field.value.trim() === '') {
                const fieldContainer = field.closest('.input-container')
                fieldContainer.classList.add('invalid-input');
            }
        });
    }

    generateRequestMessage(fields) {
        let messageParts = [];
        if (this.id === 'prenotala-modal') {
            messageParts.push('Mi interessa la ' + this.carName + ' e vorrei poterla prenotare. Grazie')
        } else if (this.id === 'test-drive-modal') {
            messageParts.push('Mi interessa la ' + this.carName + ' e vorrei prenotare un test drive. Grazie')
        } else if (this.id === 'car-info-modal') {
            messageParts.push('Mi interessa la ' + this.carName + ' e vorrei maggiori informazioni. Grazie')
        }
        messageParts.push('')
        if (fields.nome?.trim()) messageParts.push(`Nome: ${fields.nome}`);
        if (fields.cognome?.trim()) messageParts.push(`Cognome: ${fields.cognome}`);
        if (fields.email?.trim()) messageParts.push(`Email: ${fields.email}`);
        if (fields.telefono?.trim()) messageParts.push(`Telefono: ${fields.telefono}`);
        if (fields.data?.trim()) messageParts.push(`Data Preferita: ${fields.data}`);
        if (fields.orario?.trim()) messageParts.push(`Orario Preferito: ${fields.orario}`);
        if (fields.note?.trim()) messageParts.push(`Note: ${fields.note}`);
        messageParts.push(`\nURL: ${window.location.href}`);

        return messageParts.join('\n');
    }

    generateFormFields() {
        return `
            <div class="booking-modal__field--container">
                <div class="booking-modal__field--title">Nome *</div>
                <div class="input-container booking-modal__field">
                    <input type="text" id="nome" name="nome" placeholder="Inserisci il tuo nome" required>
                </div>
            </div>
            <div class="booking-modal__field--container">
                <div class="booking-modal__field--title">Cognome *</div>
                <div class="input-container booking-modal__field">
                    <input type="text" id="cognome" name="cognome" placeholder="Inserisci il tuo cognome" required>
                </div>
            </div>
            <div class="booking-modal__field--container">
                <div class="booking-modal__field--title">Email *</div>
                <div class="input-container booking-modal__field">
                    <input type="email" id="email" name="email" placeholder="Inserisci la tua email" required>
                </div>
            </div>
            <div class="booking-modal__field--container">
                <div class="booking-modal__field--title">Numero di Telefono *</div>
                <div class="input-container booking-modal__field">
                    <input type="text" id="telefono" name="telefono" placeholder="Numero di Telefono" required>
                </div>
            </div>
            <div class="booking-modal__field--container">
                <div class="booking-modal__field--title">Data Preferita</div>
                <div class="input-container booking-modal__field">
                    <input type="date" id="data" name="data" placeholder="Scegli una Data">
                </div>
            </div>
            <div class="booking-modal__field--container">
                <div class="booking-modal__field--title">Orario Preferito</div>
                <div class="input-container booking-modal__field">
                    <input type="time" id="orario" name="orario" placeholder="Scegli un Orario">
                </div>
            </div>
            <div class="booking-modal__field--container">
                <div class="booking-modal__field--title">Note o Commenti</div>
                <div class="input-container booking-modal__field">
                    <textarea id="note" name="note" rows="4" placeholder="Aggiungi Note o Commenti"></textarea>
                </div>
            </div>
        `;
    }

    collectFormData() {
        const data = {};
        this.querySelectorAll('.input-container input, .input-container textarea').forEach(field => {
            data[field.name] = field.value;
        });
        return data;
    }
}

// Register the custom element
customElements.define('booking-modal', BookingModal);


class WhatsappWidget extends HTMLElement {
    constructor() {
        super();
        // Define the modal's structure
        const whatsappMessage = 'Ciao! Sto navigando il vostro sito e vorrei avere più informazioni sulle auto disponibili. Grazie!'
        this.innerHTML = `
            <a target="_blank" class="whatsapp-widget__link" href="https://api.whatsapp.com/send?phone=393517220182&text=${encodeURIComponent(whatsappMessage)}">
            <div class="whatsapp-widget">
                <div class="whatsapp-widget__content">
                <img src="/wp-content/themes/autovi/assets/images/svg/whatsapp_green.svg" alt="">
                </div>
            </div>
            </a>
        `;
    }
}

// Register the custom element
customElements.define('whatsapp-widget', WhatsappWidget);

function captureAndAppend(nodeSelector, targetSelector) {

    const node = document.querySelector(nodeSelector);

    if (!node) {
        //console.warn(`Node not found for selector: ${nodeSelector}`);
        return;
    }

    html2canvas(node)
        .then((canvas) => {
            // Create an image element from the canvas
            const img = document.createElement('img');
            img.src = canvas.toDataURL('image/png');
            img.alt = 'Screenshot';

            // Append the image to the target element
            const target = document.querySelector(targetSelector);
            if (target) {
                target.insertBefore(img, node);
                node.remove()
            } else {
                console.error(`Target not found for selector: ${targetSelector}`);
            }
        })
        .catch((error) => {
            console.error('Error capturing screenshot:', error);
        });
}

// Example Usage
document.addEventListener('DOMContentLoaded', () => {
    captureAndAppend('#captureThis', '#appendHere');
    //captureAndAppend('#captureThis2', '#appendHere');

    document.querySelectorAll('[data-print-pdf]').forEach(trigger => {
        trigger.disabled = false
    })

});

function printToPDF(selector, fileName = 'document', includeSelector = 'print-include') {
    const element = document.querySelector(`${selector}`);

    if (!element) {
        console.error(`No element found for selector: ${selector}`);
        return;
    }

    // Clone the element to avoid modifying the original DOM
    //const clone = element.cloneNode(true);

    /*const includeElements = document.querySelectorAll(`.${includeSelector}`)
    const clone = document.createElement('div')
    includeElements.forEach(el => {
        clone.appendChild(el)
    })*/

    /*    // Function to recursively filter elements
       const filterElements = (parent) => {
            Array.from(parent.children).forEach((child) => {
                const hasIncludeClass = child.classList.contains(includeSelector);
                const hasNestedIncludeClass = child.querySelector(`.${includeSelector}`);

                if (!hasIncludeClass && !hasNestedIncludeClass) {
                    parent.removeChild(child); // Remove the child if it doesn't match the criteria
                } else if (child.children.length > 0) {
                    // Recursively filter child elements
                    filterElements(child);
                }
            });
        };

        // Start filtering the cloned element
        filterElements(clone);*/

    // Initialize jsPDF

    const {jsPDF} = window.jspdf;
    const pdf = new jsPDF('p', 'mm', 'a4');

    // Extract text and images from the filtered element
    let yPosition = 10; // Initial Y position in mm for PDF content
    const contentWidth = 190; // PDF width minus margins
    let page = 0;
    element.querySelectorAll('*').forEach((node) => {
        if (node.tagName.includes('H')) {
            const tagName = node.tagName
            if (tagName === 'H1') {
                pdf.setFontSize(22); // Font size for <h1>
            } else if (tagName === 'H2') {
                pdf.setFontSize(20); // Font size for <h2>
            } else if (tagName === 'H3') {
                pdf.setFontSize(18); // Font size for <h3>
            } else if (tagName === 'H4') {
                pdf.setFontSize(16); // Font size for <h3>
            }
            pdf.setFont('', 'bold');
            pdf.text(node.textContent.trim(), 10, yPosition);
            yPosition += 10;
        } else if (node.tagName === 'P' || node.tagName === 'DIV' || node.tagName === 'LI') {
            const tagName = node.tagName
            let xPosition = 10;
            pdf.setFontSize(12);
            pdf.setFont('', 'bold');
            if (tagName === 'LI') {
                xPosition = 15; // Font size for <h1>
                pdf.setFontSize(10);
                pdf.setFont('', 'normal');
            }
            // Adjust font size for paragraphs
            pdf.text(node.textContent.trim(), xPosition, yPosition, {maxWidth: contentWidth});
            yPosition += 8;
        } else if (node.tagName === 'IMG') {
            const imgSrc = node.getAttribute('src');
            const alt = node.getAttribute('alt');

            let imgWidth = 160; // Desired width in mm

            if (alt === 'Screenshot') {
                imgWidth = 140; // Desired width in mm
            }
            let imgHeight = (node.height / node.width) * imgWidth; // Scale height proportionally
            //pdf.addImage(imgSrc, "JPEG", 15, 40, 180, 180);
            pdf.addImage(imgSrc, 'JPEG', 10, yPosition, imgWidth, imgHeight);
            if (alt === 'Screenshot' && page === 0) {
                pdf.addPage("a4");
                yPosition = 20
                page++;
            } else {
                yPosition += imgHeight + 15;
            }
        }
        if (yPosition >= 270) {
            pdf.addPage("a4");
            yPosition = 20
            page++;
        }
    });

    // Save the PDF
    pdf.save(`${fileName}.pdf`);
}

document.querySelectorAll('[data-print-pdf]').forEach(trigger => {
    trigger.addEventListener('click', () => {
        printToPDF(trigger.getAttribute('data-print-pdf'))
    })
})

//car images zoom
class CarSliderModal extends HTMLElement {
    constructor() {
        super();
        this.modal = null;
        this.sliderCopy = null;
    }

    connectedCallback() {
        this.render();

        // Open modal when clicked
        this.addEventListener('click', () => {
            const slider = document.querySelector('slider-component'); // Find the slider
            if (slider) this.open(slider);
        });

        if (!isMobile()) {
            this.initSlidesClickListener()
        }

    }

    render() {
        // Create modal container
        this.modal = document.createElement('div');
        this.modal.classList.add('car-slider-modal');
        this.modal.innerHTML = `
        <div class="car-slider-modal__overlay"></div>
        <div class="car-slider-modal__content">
            <span class="car-slider-modal__close">&times;</span>
            <div class="car-slider-modal__slider-container"></div>
            <div class="car-slider-modal__thumbnails"></div> <!-- Thumbnails will be generated here -->
        </div>
    `;

        document.body.appendChild(this.modal);

        // Close on overlay or button click
        this.modal.querySelector('.car-slider-modal__overlay').addEventListener('click', () => this.close());
        this.modal.querySelector('.car-slider-modal__close').addEventListener('click', () => this.close());

        // Close on ESC key
        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') this.close();
        });
    }


    open(slider, clickedSlide = null) {
        if (!slider) return;

        // Get the original slider's scroll position and dimensions
        const container = slider.querySelector('.slider-component__slides-wrapper');
        const totalScrollWidth = container.scrollWidth - container.clientWidth;
        const scrollPercentage = totalScrollWidth > 0 ? container.scrollLeft / totalScrollWidth : 0;

        // Clone slider
        this.sliderCopy = slider.cloneNode(true);
        this.sliderCopy.classList.add('zoomed-slider'); // Optional: Add zoom styling

        // Add cloned slider inside modal
        const sliderContainer = this.modal.querySelector('.car-slider-modal__slider-container');
        sliderContainer.innerHTML = '';
        sliderContainer.appendChild(this.sliderCopy);

        // Generate thumbnails
        this.generateThumbnails(slider);

        // Ensure cloned slider has the same proportional scroll position
        const clonedContainer = this.sliderCopy.querySelector('.slider-component__slides-wrapper');

        requestAnimationFrame(() => {
            if (clickedSlide) {
                // If a slide was clicked, scroll to the corresponding slide in modal
                const slideIndex = Array.from(slider.querySelectorAll('.slider-component__slide')).indexOf(clickedSlide);
                const clonedSlides = clonedContainer.querySelectorAll('.slider-component__slide');
                if (clonedSlides[slideIndex]) {
                    clonedSlides[slideIndex].scrollIntoView({behavior: 'instant', block: 'nearest', inline: 'center'});
                }
            } else {
                // Default: Maintain proportional scroll position
                const clonedTotalScrollWidth = clonedContainer.scrollWidth - clonedContainer.clientWidth;
                clonedContainer.scrollLeft = clonedTotalScrollWidth * scrollPercentage;
            }
        });

        // Show modal
        this.modal.style.display = 'flex';

        // Delay animation for smooth appearance
        setTimeout(() => {
            this.modal.classList.add('visible');
        }, 50);
    }


    close() {
        this.modal.classList.remove('visible');
        setTimeout(() => {
            this.modal.style.display = 'none';
        }, 300);
    }

    initSlidesClickListener() {

        const slides = this.closest('.car-carousel').querySelectorAll('.car-slide-image.slider-component__slide, .car-carousel__slide')

        slides.forEach(slide => {
            slide.style.cursor = 'zoom-in'

            slide.addEventListener('click', () => {
                const slider = slide.closest('slider-component') || slide.closest('.car-carousel').querySelector('slider-component');
                if (slider) this.open(slider);
            });
        })
    }

    generateThumbnails(slider) {
        const thumbnailsContainer = this.modal.querySelector('.car-slider-modal__thumbnails');
        thumbnailsContainer.innerHTML = ''; // Clear previous thumbnails

        const slides = slider.querySelectorAll('.slider-component__slide');

        slides.forEach((slide, index) => {
            const img = slide.querySelector('img');
            if (!img) return; // Skip if no image

            // Create thumbnail
            const thumb = document.createElement('div');
            thumb.classList.add('car-thumbnail');
            thumb.dataset.index = index;
            thumb.innerHTML = `<img src="${img.src}" alt="Thumbnail">`;

            // Add click event to scroll to selected slide
            thumb.addEventListener('click', () => {
                const clonedContainer = this.sliderCopy.querySelector('.slider-component__slides-wrapper');
                const clonedSlides = clonedContainer.querySelectorAll('.slider-component__slide');
                if (clonedSlides[index]) {
                    clonedSlides[index].scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'center'});
                }
            });

            // Append thumbnail to container
            thumbnailsContainer.appendChild(thumb);
        });
    }


}

// Define the custom element
customElements.define('car-slider-modal', CarSliderModal);


class CarsListing extends HTMLElement {
    constructor() {
        super();

    }

    async connectedCallback() {
        const that = this
        const filtersForm = this.querySelector("#filters_form");
        const sortForm = this.querySelector("#car-sort-form");

        // Attach submit event listeners to both forms
        filtersForm?.addEventListener("submit", (event) => this.handleSearchFormsSubmit(event, filtersForm), true);

        this.attachSortListeners()

        if (filtersForm) {
            await this.fetchCarsData(filtersForm, sortForm, true)
            this.fetchCarsData(filtersForm, sortForm)
            filtersForm?.addEventListener('change', function (event) {
                event.preventDefault();
                that.fetchCarsData(filtersForm, sortForm)
            });

            this.loadAndInitializeChoices(filtersForm)
        }

        this.stickyFiltersOnMobile()
    }

    handleSearchFormsSubmit(event = null, formToSubmit) {
        const filtersForm = this.querySelector("#filters_form");
        const sortForm = this.querySelector("#car-sort-form");

        if (event) event.preventDefault(); // Prevent default form submission
        // Create a FormData object to gather data from both forms
        const formData = new FormData(filtersForm);
        new FormData(sortForm).forEach((value, key) => {
            formData.set(key, value); // Add/overwrite sort form data into the combined formData
        });

        const params = {};

        // Grouping values by keys
        formData.forEach((value, key) => {
            if (params[key]) {
                if (Array.isArray(params[key])) {
                    params[key].push(value);
                } else {
                    params[key] = [params[key], value];  // Convert to array if second occurrence
                }
            } else {
                params[key] = value;
            }
        });


        // Create a new form to submit combined data
        const combinedForm = document.createElement("form");
        combinedForm.method = "GET";
        combinedForm.action = formToSubmit.action;


        // Append all grouped parameters as hidden inputs to the new form
        Object.entries(params).forEach(([key, values]) => {
            if (Array.isArray(values)) {
                values.forEach(value => {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = `${key}[]`;  // Use array notation for the name
                    input.value = value;
                    combinedForm.appendChild(input);
                });
            } else {
                const input = document.createElement("input");
                input.type = "hidden";
                input.name = key;
                input.value = values;
                combinedForm.appendChild(input);
            }
        });


        // Append the combined form to the body and submit it
        document.body.appendChild(combinedForm);

        combinedForm.submit();
    }

    updateFilterOptions(filtersForm) {
        function getActiveOptionsGroups(filters) {
            // Initialize an array to hold groups of active options
            let groupedOptions = [];

            // Loop over each filter
            filters.forEach(filter => {
                if (filter.selectedOptions && filter.selectedOptions.length > 0) {
                    // Collect all active options for this filter
                    let options = Array.from(filter.selectedOptions)
                        .filter(option => option.value) // Ensure the option has a value
                        .map(option => option.value); // Collect only the values

                    // Create an object for this filter with its name and active options
                    if (options.length > 0) {
                        groupedOptions.push({
                            filterName: filter.name,
                            activeOptions: options
                        });
                    }
                }
            });

            // Return the array of groups with filter names and their corresponding active options
            return groupedOptions;
        }

        const data = this.allCarsData

        const allMetaSelectFilters = Array.from(filtersForm.querySelectorAll('select'))
        allMetaSelectFilters.forEach(currentFilter => {
            const otherFilters = allMetaSelectFilters.filter(f => f !== currentFilter);
            const activeOptionsGroups = getActiveOptionsGroups(otherFilters);

            Array.from(currentFilter.options).filter(option => option.value).forEach(option => {
                // Test if there's at least one car matching the filter conditions
                const resultExists = data.find(car =>
                        (car[currentFilter.name] === option.value || car[currentFilter.name].includes(option.value)) && activeOptionsGroups.every(group =>
                            group.activeOptions.some(activeOption =>
                                car[group.filterName] === activeOption || car[group.filterName].includes(activeOption))
                        )
                );

                // Enable or disable based on whether any cars match the simulated active options

                option.disabled = !resultExists;
                if (option.selected && !resultExists) {
                    option.selected = false
                    currentFilter.choices.removeChoice(option.value)
                }

            });

            // If using Choices.js to enhance select elements
            if (currentFilter.choices) {
                currentFilter.choices.refresh();
            }
        });


        const allMetaBooleanFilters = filtersForm.querySelectorAll('.type_boolean input')
        // Disable options based on the existence of corresponding data
        allMetaBooleanFilters.forEach(booleanOption => {
            const resultExists = data.some(car => {
                const property = car[booleanOption.name];
                return property === '1'; // Check if string is exactly equal to the option value
            });

            // Get the closest filter field element for style manipulation
            const filterField = booleanOption.closest('.filters__field');

            // Set disabled state and opacity based on whether a matching result exists
            booleanOption.disabled = !resultExists;
            filterField.style.opacity = !resultExists ? '0.5' : '1';
        });

        const allRangeSliders = filtersForm.querySelectorAll('range-slider')
        allRangeSliders.forEach(rangeSlider => {
            rangeSlider.createDistributionBars()
        })
    }

    updateResults() {

        const component = this.listingComponent

        const carsListing = document.querySelector('.cars-listing .cars-listing__right')

        // Create a temporary div element
        const tempDiv = document.createElement('div');
        // Set its innerHTML to the received HTML string
        tempDiv.innerHTML = component;

        // Assuming the outer structure of `listingComponent` is similar,
        // extract only the inner part you need:
        carsListing.innerHTML = tempDiv.querySelector('.cars-listing__right').innerHTML
        carsListing.style.transition = 'opacity 0.1s ease-in-out'
        carsListing.style.opacity = '1'

        this.attachSortListeners()

    }

    async fetchCarsData(filtersForm, sortForm, getAllCars = false) {

        const apiUrl = new URL(`${window.location.origin}/wp-json/car-manager/v1/update-filters`)

        let newSearchParameters
        if (!getAllCars) {
            const formData = new FormData(filtersForm);
            new FormData(sortForm).forEach((value, key) => {
                formData.set(key, value); // Add/overwrite sort form data into the combined formData
            });
            // Append form data as query parameters
            const params = {};

// Collect all parameters into an object, grouping values by key
            formData.forEach((value, key) => {
                if (params[key]) {
                    if (Array.isArray(params[key])) {
                        params[key].push(value);
                    } else {
                        params[key] = [params[key], value]; // Convert to array if second occurrence
                    }
                } else {
                    params[key] = value;
                }
            });

// Append parameters to apiUrl, add brackets for arrays
            Object.entries(params).forEach(([key, value]) => {
                if (Array.isArray(value)) {
                    value.forEach(singleValue => apiUrl.searchParams.append(`${key}[]`, singleValue));
                } else {
                    apiUrl.searchParams.append(key, value);
                }
            });

            newSearchParameters = new URLSearchParams(apiUrl.search)
        }

        await fetch(apiUrl, {
            method: 'GET',
            credentials: 'same-origin'
        })
            .then(response => {
                return response.json()
            })
            .then(data => {
                if (getAllCars) {
                    this.allCarsData = data.carsData
                }
                this.currentCarsData = data.carsData
                this.listingComponent = data.listingComponent
                this.updateFilterOptions(filtersForm)
                if (!getAllCars) {
                    this.updateResults()
                    // Update the browser URL without reloading the page
                    history.pushState(null, '', `${window.location.pathname}?${newSearchParameters.toString()}`);
                }

            })
            .catch(error => console.error('Error fetching filter updates:', error));
    }

    loadAndInitializeChoices(filtersForm) {
        // Check if there are any select elements with 'multiple' attribute
        const selects = filtersForm.querySelectorAll('select');
        if (selects.length > 0) {

            // Load Choices.js CSS
            const head = document.getElementsByTagName('head')[0];
            const choicesCSS = document.createElement('link');
            choicesCSS.type = 'text/css';
            choicesCSS.rel = 'stylesheet';
            choicesCSS.href = 'https://cdn.jsdelivr.net/npm/choices.js/public/assets/styles/choices.min.css';
            head.appendChild(choicesCSS);

            // Load Choices.js and initialize Choices
            const choicesScript = document.createElement('script');
            choicesScript.src = 'https://cdn.jsdelivr.net/npm/choices.js/public/assets/scripts/choices.min.js';
            choicesScript.onload = function () {
                // Once script is loaded, initialize Choices on all multiple selects
                selects.forEach(select => {
                    const selectType = Array.from(select.closest('.filters__field').classList).find(className => className.includes('type_'));
                    select.choices = new Choices(select, {
                        removeItemButton: true,  // allows user to remove a selected item
                        searchEnabled: false,
                        itemSelectText: 'Clicca per selezionare',
                        noResultsText: 'Nessun risultato trovato, selezionare dalla lista',
                        noChoicesText: 'Nessuna opzione disponibile',
                    });
                });
            };
            document.body.appendChild(choicesScript);
        }
    }

    stickyFiltersOnMobile() {
        const that = this
        this.filterContainer = this.querySelector('.cars-listing__left')

        function checkVisibility(filterContainer) {

            const targetElement = that.querySelector('.cars-listing__cars');

            if (!filterContainer || !targetElement) return;
            const targetRect = targetElement.getBoundingClientRect();
            const isAtTop = targetRect.top <= 0; // Check if top of the element is at or passed the top of the viewport

            // Toggle 'sticky' class based on visibility
            filterContainer.classList.toggle('sticky', isAtTop);
        }

        const debouncedCheckVisibility = debounce(() => checkVisibility(this.filterContainer), 100); // Debounce time of 100 milliseconds

        // Setup event listeners only if on a mobile device
        if (window.matchMedia("(max-width: 768px)").matches) {
            window.addEventListener('scroll', () => {
                debouncedCheckVisibility()
            });
            document.addEventListener('DOMContentLoaded', debouncedCheckVisibility);
        }
    }

    attachSortListeners() {
        const that = this

        const sortForm = this.querySelector("#car-sort-form");
        sortForm?.addEventListener("submit", (event) => this.handleSearchFormsSubmit(event, sortForm), true);

        const sorter = sortForm.querySelector('#sort-by')
        sorter.addEventListener('change', function () {
            const form = document.getElementById('car-sort-form');
            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search);

            // Update the 'sort' parameter
            params.set('sort', that.value);

            // Update the form's action with the updated query string
            form.action = `${url.pathname}?${params.toString()}`;
            that.handleSearchFormsSubmit(null, form)

        });
    }

}

// Define the custom element
customElements.define('cars-listing', CarsListing);

class CarTool extends HTMLElement {
    constructor() {
        super();
        this.formPages = [];
        this.currentPageIndex = 0;
        this.pageElements = []; // Store references to page containers
    }

    connectedCallback() {
        /*this.buildPages();
        this.showPage(this.currentPageIndex);*/ // Initially show the first page
    }

    set pages(pages) {
        this.formPages = pages;
        this.buildPages();
        this.showPage(0); // Reset to the first page and show it
    }

    get pages() {
        return this.formPages;
    }

    buildPages() {
        this.innerHTML = ''; // Clears the current content only when rebuilding
        const frame = document.createElement('div');
        frame.className = 'car-tool__frame';

        this.formPages.forEach((page, index) => {
            const pageContainer = this.createPage(page, index);
            pageContainer.style.display = 'none'; // Initially hide all pages
            this.pageElements[index] = pageContainer; // Store the reference
            frame.appendChild(pageContainer);
        });

        //populate dynamic fields
        const marchioSelect = frame.querySelector('#marchio');

        // Fetch Marchio terms
        fetch(`${window.location.origin}/wp-json/car-manager/v1/terms?taxonomy=marchio`)
            .then((response) => response.json())
            .then((data) => {
                if (Array.isArray(data)) {
                    // Populate the dropdown with fetched terms
                    const option = document.createElement('option');
                    option.value = '';
                    option.textContent = 'Marca: Tutte';
                    option.selected = option.disabled = true
                    marchioSelect?.appendChild(option);
                    data.forEach((term) => {
                        const option = document.createElement('option');
                        option.value = term.slug;
                        option.textContent = term.name;
                        marchioSelect?.appendChild(option);
                    });
                } else {
                    console.error('Failed to fetch marchio terms:', data);
                }
            })
            .catch((error) => {
                console.error('Error fetching marchio terms:', error);
            });

        marchioSelect?.addEventListener('change', function () {
            const selectedMarchio = this.value;
            const modelloSelect = frame.querySelector('#modello');
            // Disable the modello dropdown while loading
            modelloSelect.disabled = true;

            if (selectedMarchio) {
                modelloSelect.innerHTML = '<option value="" disabled selected>Caricamento...</option>';
                // Fetch Modello terms based on the selected Marchio
                fetch(`${window.location.origin}/wp-json/car-manager/v1/terms?taxonomy=modello&marchio=${selectedMarchio}`)
                    .then((response) => response.json())
                    .then((data) => {
                        if (Array.isArray(data)) {
                            modelloSelect.innerHTML = '<option value="" disabled selected>Modello: Tutti</option>';
                            data.forEach((term) => {
                                const option = document.createElement('option');
                                option.value = term.slug;
                                option.textContent = term.name;
                                modelloSelect.appendChild(option);
                            });
                            modelloSelect.disabled = false;
                        } else {
                            modelloSelect.innerHTML = '<option value="" disabled>No Modelli Available</option>';
                        }
                    })
                    .catch((error) => {
                        console.error('Error fetching modello terms:', error);
                        modelloSelect.innerHTML = '<option value="" disabled>Error loading Modelli</option>';
                    });
            }

        });

        this.appendChild(frame);
    }

    createPage(page, pageIndex) {

        const that = this

        const pageContainer = document.createElement('div');
        pageContainer.className = 'car-tool__page basic-block-24';

        const titleWithText = document.createElement('div');
        titleWithText.className = 'title-with-text';

        const titleContainer = document.createElement('div');
        titleContainer.className = 'title-with-text__container';

        const title = document.createElement('div');
        title.className = 'title-with-text__title heading-2';
        title.textContent = page.title;

        const text = document.createElement('div');
        text.className = 'title-with-text__text text-large';
        text.textContent = page.text;

        titleContainer.appendChild(title);
        titleContainer.appendChild(text);
        titleWithText.appendChild(titleContainer);
        pageContainer.appendChild(titleWithText);

        const fieldsContainer = document.createElement('div');
        fieldsContainer.className = 'car-tool__fields basic-block-40';

        page.fields?.forEach(field => {
            const fieldContainer = document.createElement('div');
            fieldContainer.className = 'car-tool__field basic-block-12';

            const fieldTitle = document.createElement('div');
            fieldTitle.className = 'car-tool__field--title';
            fieldTitle.innerHTML = field.label + (field.mandatory !== false ? '<span style="opacity: 0.7; margin-left: 3px">*</span>' : '');

            let fieldDesc
            if (field.description) {
                fieldDesc = document.createElement('div');
                fieldDesc.className = 'car-tool__field--desc';
                fieldDesc.textContent = field.description;
            }

            const inputContainer = document.createElement('div');
            inputContainer.className = 'car-tool__field--input-container basic-block-12';

            if (field.type === 'checkbox') fieldContainer.style.flexDirection = 'row-reverse'
            if (field.type === 'checkbox') fieldContainer.style.justifyContent = 'flex-end'
            if (field.master) fieldContainer.setAttribute('master', field.master)

            // Switch to handle different types of fields
            let inputElement;
            let storedFiles = [];

            function updateFileInput(files) {
                const dataTransfer = new DataTransfer();
                files.forEach(file => dataTransfer.items.add(file));
                inputElement.files = dataTransfer.files;
            }

            function generateFilePreviews(files, container) {
                // Clear existing previews to avoid duplicates
                container.innerHTML = '';
                const addButton = that.querySelector('.add-photo-btn')

                // Maintain the order of files based on their addition
                files.forEach((file, index) => {
                    const fileReader = new FileReader();
                    fileReader.onload = function (e) {
                        const imgContainer = document.createElement('div');
                        imgContainer.className = 'img-preview';
                        imgContainer.style.position = 'relative'

                        const img = document.createElement('img');
                        img.src = e.target.result;
                        img.style.aspectRatio = '1.8';
                        img.style.objectFit = 'cover';

                        // Add remove button for each image
                        const removeBtn = document.createElement('button');
                        removeBtn.textContent = 'Elimina';
                        removeBtn.className = 'remove-img-btn';
                        removeBtn.style.position = 'absolute';
                        removeBtn.style.top = '12px';
                        removeBtn.style.right = '12px';
                        removeBtn.style.padding = '10px';
                        removeBtn.style.color = 'red';
                        removeBtn.onclick = function () {
                            // Remove the file from the array
                            storedFiles.splice(index, 1);
                            updateFileInput(storedFiles);
                            generateFilePreviews(storedFiles, container);


                            if (storedFiles.length >= 10) {
                                addButton.style.display = 'none'
                            } else {
                                addButton.style.display = 'flex'
                            }
                        };

                        imgContainer.appendChild(img);
                        imgContainer.appendChild(removeBtn);
                        container.appendChild(imgContainer);
                    };
                    fileReader.readAsDataURL(file);
                });
            }

            switch (field.type) {
                case 'select':
                    inputElement = document.createElement('select');
                    inputElement.name = field.name;
                    field.options.forEach(option => {
                        const opt = document.createElement('option');
                        opt.value = option === 'Modello: Tutti'? '' : option;
                        opt.textContent = option;
                        inputElement.appendChild(opt);
                    });
                    break;
                case 'text':
                case 'email':
                case 'date':
                    inputElement = document.createElement('input');
                    inputElement.type = field.type;
                    inputElement.name = field.name;
                    break;
                case 'number':
                    inputElement = document.createElement('input');
                    inputElement.type = field.type;
                    inputElement.name = field.name;
                    break;
                case 'textarea':
                    inputElement = document.createElement('textarea');
                    inputElement.name = field.name;
                    break;
                case 'boolean':
                    // Custom toggle switch
                    inputElement = document.createElement('label');
                    inputElement.className = 'switch';
                    const checkbox = document.createElement('input');
                    checkbox.type = 'checkbox';
                    checkbox.name = field.name
                    const slider = document.createElement('span');
                    slider.className = 'slider round';
                    const leftLabel = document.createElement('span')
                    leftLabel.className = 'label-text cm'
                    leftLabel.innerText = 'No'
                    const rightLabel = document.createElement('span')
                    rightLabel.className = 'label-text ft'
                    rightLabel.innerText = 'Sì'
                    inputElement.appendChild(leftLabel);
                    inputElement.appendChild(checkbox);
                    inputElement.appendChild(slider);
                    inputElement.appendChild(rightLabel);
                    break;
                case 'checkbox':
                    // Create the outer container div
                    const containerDiv = document.createElement('div');
                    containerDiv.className = 'custom-checkbox__container custom-checkbox__labeled';

                    // Create the label element
                    const label = document.createElement('label');

                    // Create the checkbox input
                    const checkboxInput = document.createElement('input');
                    checkboxInput.type = 'checkbox';
                    checkboxInput.name = field.name;

                    // Create the custom checkbox span
                    const customCheckbox = document.createElement('span');
                    customCheckbox.className = 'custom-checkbox';

                    // Append the input and span to the label
                    label.appendChild(checkboxInput);
                    label.appendChild(customCheckbox);

                    // Append the label to the container div
                    containerDiv.appendChild(label);

                    // Set inputElement to the outer container for consistency with other cases
                    inputElement = containerDiv;
                    break;
                case 'file':
                    // Create a custom button that triggers the file input
                    const addButton = document.createElement('button');
                    addButton.textContent = 'Aggiungi foto 📷';
                    addButton.className = 'button-large button button-primary button-with-icon add-photo-btn';

                    inputElement = document.createElement('input');
                    inputElement.name = field.name;
                    inputElement.type = 'file';
                    inputElement.accept = 'image/*';
                    inputElement.multiple = true;
                    inputElement.style.display = 'none'; // Hide the actual file input

                    addButton.onclick = function () {
                        inputElement.click();
                    };

                    // Create a container to display thumbnails of uploaded files
                    const previewContainer = document.createElement('div');
                    previewContainer.className = 'preview-container';
                    previewContainer.style.display = 'flex';
                    previewContainer.style.flexDirection = 'column';
                    previewContainer.style.gap = '20px';

                    // Event listener to update the display as files are uploaded
                    inputElement.addEventListener('change', function (event) {
                        // Concatenate new files to the existing array
                        storedFiles = storedFiles.concat(Array.from(event.target.files));

                        if (storedFiles.length > 10) {
                            storedFiles = storedFiles.slice(0, 10); // Keep only the first 10 items
                        }

                        // Update the file input with all selected files
                        updateFileInput(storedFiles);

                        // Generate previews for new files
                        generateFilePreviews(storedFiles, previewContainer);

                        if (storedFiles.length >= 10) {
                            addButton.style.display = 'none'
                        } else {
                            addButton.style.display = 'flex'
                        }
                    });

                    inputContainer.appendChild(previewContainer);
                    inputContainer.appendChild(addButton);
                    break;
                default:
                    inputElement = document.createElement('input');
                    inputElement.type = 'text'; // Default to text if type is not specified
            }

            inputElement.placeholder = field.placeholder
            if (field.id) {
                inputElement.id = field.id
            }

            if (field.mandatory !== false) {

                if (['input', 'select'].includes(inputElement.tagName.toLowerCase())) {
                    inputElement.required = true
                } else {
                    inputElement.querySelector('input, select').required = true
                }
                console.debug('field.mandatory', inputElement)
            }

            let icon
            switch (field.type) {
                case 'select':
                    icon = document.createElement('div');
                    icon.className = 'icon'
                    icon.innerHTML = `
                                    <svg width="15" height="7" viewBox="0 0 15 7" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7.00003 7.00003C6.76638 7.00049 6.53994 6.91911 6.36003 6.77003L0.360032 1.77003C0.155815 1.60029 0.0273905 1.35638 0.0030108 1.09196C-0.0213689 0.827529 0.060293 0.564248 0.230032 0.360031C0.39977 0.155814 0.643682 0.0273905 0.908108 0.00301082C1.17253 -0.0213689 1.43581 0.0602925 1.64003 0.230031L7.00003 4.71003L12.36 0.390032C12.4623 0.306966 12.58 0.244934 12.7064 0.207502C12.8327 0.170071 12.9652 0.157977 13.0962 0.171916C13.2272 0.185855 13.3542 0.225552 13.4699 0.288726C13.5855 0.3519 13.6875 0.437305 13.77 0.540031C13.8616 0.642853 13.931 0.763479 13.9738 0.894353C14.0166 1.02523 14.0319 1.16353 14.0187 1.30059C14.0056 1.43765 13.9643 1.57053 13.8974 1.69088C13.8305 1.81124 13.7395 1.91649 13.63 2.00003L7.63003 6.83003C7.44495 6.95555 7.22313 7.0154 7.00003 7.00003Z"
                                              fill="#6B7588"/>
                                    </svg>`
                    break;
            }

            const inputWrapper = document.createElement('div');
            if (field.type === 'boolean') {
                inputWrapper.className = 'custom-converter';
            } else if (field.type === 'file' || field.type === 'checkbox') {
                inputWrapper.className = ''; // No class for file type
            } else {
                inputWrapper.className = `input-container ${field.type}-input`;
            }
            inputWrapper.appendChild(inputElement);
            if (icon) inputWrapper.appendChild(icon);
            inputContainer.appendChild(inputWrapper);

            fieldContainer.appendChild(fieldTitle);
            if (fieldDesc) {
                fieldContainer.appendChild(fieldDesc);
            }
            fieldContainer.appendChild(inputContainer);
            fieldsContainer.appendChild(fieldContainer);
        });

        pageContainer.appendChild(fieldsContainer);

        if (pageIndex < this.formPages.length - 1) {
            // Create CTA container
            const ctaContainer = document.createElement('div');
            ctaContainer.className = 'car-tool__cta';

            if (pageIndex > 0) {
                const arrowIconPrev = `<div class="icon" style="transform: rotate(180deg)"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.45043 14.3001L14.7488 8.00007L8.44883 1.70007M1.25043 8.00007H14.7504H1.25043Z" stroke="var(--primaryColor)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>`
                const backButton = document.createElement('button');
                backButton.className = 'button-large button button-primary button-with-icon button-with-icon-left';
                backButton.innerHTML = `${arrowIconPrev}Indietro`;
                backButton.onclick = () => {
                    this.navigateBack();
                };
                ctaContainer.appendChild(backButton);
            }

            const arrowIcon = `<div class="icon"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.45043 14.3001L14.7488 8.00007L8.44883 1.70007M1.25043 8.00007H14.7504H1.25043Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>`
            const button = document.createElement('button');
            button.className = 'button-large button button-primary button-with-icon button-with-icon-right';
            button.innerHTML = pageIndex < this.formPages.length - 2 ? `${arrowIcon}Avanti` : 'Invia &#10004;';
            button.onclick = () => {
                if (pageIndex < this.formPages.length - 1) {
                    this.navigateToNextPage();
                    if (pageIndex === this.formPages.length - 2) {
                        this.submitForm();
                    }
                }
            };

            ctaContainer.appendChild(button);
            fieldsContainer.appendChild(ctaContainer);

        }


        const masterFields = pageContainer.querySelectorAll(`input[name]`);
        masterFields.forEach(masterField => {
            masterField.addEventListener('change', function () {
                const slaveFields = pageContainer.querySelectorAll(`[master="${masterField.name}"]`);
                slaveFields.forEach(slaveField => {
                    if (masterField.checked) {
                        slaveField.style.display = 'flex';
                    } else {
                        slaveField.style.display = 'none'; // Hide the field
                    } // Show the field
                })
            });
        })

        return pageContainer;
    }

    showPage(index) {
        this.pageElements.forEach((page, idx) => {
            page.style.display = idx === index ? '' : 'none'; // Toggle visibility
        });
        this.currentPageIndex = index; // Update current page index
    }

    navigateToNextPage() {
        if (this.currentPageIsValid()) {
            if (this.currentPageIndex < this.formPages.length - 1) {
                this.showPage(this.currentPageIndex + 1);
            }
        } else {
            console.debug('currentPageIsInValid')
        }

        scrollToElement(this, 120)
    }

    navigateBack() {
        if (this.currentPageIndex > 0) {
            this.showPage(this.currentPageIndex - 1);
        }
        scrollToElement(this, 120)
    }


    currentPageIsValid() {
        const currentPage = this.pageElements[this.currentPageIndex]
        const requiredFields = currentPage.querySelectorAll('[required]')

        let missingFields = []
        requiredFields.forEach(field => {
            const fieldIsInvalid = field.type === 'checkbox'? !field.checked : !field.value
            let fieldContainer = field.closest('.input-container')
            if(!fieldContainer) fieldContainer = field.closest('label').querySelector('.custom-checkbox')
            fieldContainer.classList.toggle('error', fieldIsInvalid)
            if (fieldIsInvalid) {
                missingFields.push(field)

                console.debug('requiredField', field)
                console.debug('fieldIsInvalid', fieldIsInvalid)
                console.debug('fieldContainer', fieldContainer)
            }
        })

        return missingFields.length === 0
    }

    submitForm() {
        console.debug('submitForm');

        if (this.currentPageIsValid()) {
            console.debug('fields are valid');

            const formData = new FormData();
            const fields = this.querySelectorAll('input, select, textarea');
            fields.forEach(element => {
                if (element.type === 'checkbox' || element.type === 'radio') {
                    if (element.checked) {
                        formData.append(element.name, element.value);
                    }
                } else if (element.type === 'file' && element.files.length) {
                    Array.from(element.files).forEach((file, index) => {
                        formData.append(element.name + '[]', file, file.name);
                    });
                } else {
                    formData.append(element.name, element.value);
                }
            });

            const message = this.generateSectionedRequestMessage();
            formData.append('action', 'send_email');
            formData.append('message', message);
            formData.append('subject', `Valutazione Usato | ${formData.get('marca')} ${formData.get('modello')} (${formData.get('anno')})`);
            formData.append('from', `${formData.get('nome')} ${formData.get('cognome')} <${formData.get('email')}>`);
            formData.append('request_type', 'Valutazione Usato');

            console.debug('formData', formData)

            fetch('/wp-admin/admin-ajax.php', {
                method: 'POST',
                body: formData,
                headers: {
                    'Accept': 'application/json'
                }
            })
                .then(response => response.json())
                .then(data => {
                    alert(data.message);
                })
                .catch(error => console.error('Error:', error));
        }

        scrollToElement(this, 120)
    }


    generateSectionedRequestMessage() {
        const messageParts = [];

        // Loop through each page in the pages array
        this.pages.forEach(page => {
            if (page.fields) {  // Check if the page has fields defined
                messageParts.push(page.title.toUpperCase());  // Add the page title to the message
                messageParts.push('');
                page.fields.forEach(field => {
                    if(field.type !== 'file') {
                        const element = document.querySelector(`[name="${field.name}"]`);  // Find the element by its name attribute
                        if (element) {
                            let value = element.type === 'checkbox' ? element.checked ? 'Sì' : 'No' : element.value.trim();
                            if (value) {
                                const label = field.label;  // Format the label from field name
                                messageParts.push(`${label}: ${value}`);  // Append formatted label and value to message
                            }
                        }
                    }
                });
                messageParts.push('');  // Add a blank line for separation
                messageParts.push('');
            }
        });

        return messageParts.join('\n');
    }

}

customElements.define('car-tool', CarTool);


document.addEventListener('DOMContentLoaded', function () {
    const carTool = document.querySelector('car-tool');
    if (carTool) {
        carTool.pages = [
            {
                title: "Dettagli Principali dell’Auto",
                fields: [
                    {
                        label: "Marca",
                        type: "text",
                        placeholder: "Inserisci la marca",
                        name: "marca"
                    },
                    {
                        label: "Modello",
                        type: "text",
                        placeholder: "Inserisci il modello",
                        name: "modello"
                    },
                    {
                        label: "Anno",
                        type: "text",
                        placeholder: "Anno di immatricolazione",
                        name: "anno"
                    }
                ]
            },
            {
                title: "Specifiche Tecniche",
                fields: [
                    {
                        label: "Alimentazione",
                        type: "select",
                        name: "alimentazione",
                        options: ['Benzina', 'Diesel', 'Metano', 'GPL', 'Elettrica', 'Ibrida'],
                        placeholder: "Alimentazione"
                    },
                    {
                        label: "Cambio",
                        type: "select",
                        name: "cambio",
                        options: ['Manuale', 'Automatico'],
                        placeholder: "Cambio"
                    },
                    {
                        label: "Cilindrata",
                        type: "text",
                        name: "cilindrata",
                        placeholder: "Cilindrata"
                    },
                    {
                        label: "Potenza",
                        type: "text",
                        name: "potenza",
                        placeholder: "Potenza"
                    },
                    {
                        label: "Allestimento",
                        type: "text",
                        name: "allestimento",
                        placeholder: "Allestimento",
                        mandatory: false
                    },
                    {
                        label: "Carrozzeria",
                        type: "select",
                        name: "carrozzeria",
                        options: ['City Car', 'Cabrio', 'Coupé', 'Suv/Fuoristrada/Pick-Up',
                            'Station Wagon', 'Berlina', 'Monovolume', 'Furgoni/Van', 'Altro'],
                        placeholder: "Carrozzeria"
                    },
                    {
                        label: "Porte",
                        type: "number",
                        name: "porte",
                        placeholder: "Numero Porte"
                    }
                ]
            },
            {
                title: "Stato, Storico del Veicolo e Foto",
                fields: [
                    {
                        label: "Chilometraggio",
                        type: "text",
                        name: "chilometraggio",
                        placeholder: "Chilometraggio"
                    },
                    {
                        label: "Precedenti Proprietari",
                        type: "select",
                        name: "precedenti_proprietari",
                        options: ['Nessuno', '1', '2', '3',
                            '4', 'Più di 4'],
                        placeholder: "Precedenti Proprietari"
                    },
                    {
                        label: "Colore",
                        type: "text",
                        name: "colore",
                        placeholder: "Colore"
                    },
                    {
                        label: "Sono presenti libretto uso e manutenzione?",
                        type: "boolean",
                        name: "libretto_uso_manutenzione",
                        placeholder: "Sì/No",
                        mandatory: false
                    },
                    {
                        label: "Targa",
                        type: "text",
                        name: "targa",
                        placeholder: "Targa"
                    },
                    {
                        label: "Carica Foto",
                        type: "file",
                        name: "carica_foto",
                        description: "Clicca il bottone “Aggiungi foto” per aggiungere fino a 10 foto del veicolo.",
                        mandatory: false
                    }
                ]
            },
            {
                title: "Dati Personali e Preferenze di Acquisto",
                fields: [
                    {
                        label: "Nome",
                        type: "text",
                        name: "nome",
                        placeholder: "Nome"
                    },
                    {
                        label: "Cognome",
                        type: "text",
                        name: "cognome",
                        placeholder: "Cognome"
                    },
                    {
                        label: "Email",
                        type: "email",
                        name: "email",
                        placeholder: "Email"
                    },
                    {
                        label: "Numero di Telefono",
                        type: "text",
                        name: "numero_di_telefono",
                        placeholder: "Numero di Telefono"
                    },
                    {
                        label: "Vuoi acquistare un’altra vettura dal nostro catalogo?",
                        type: "boolean",
                        name: "acquisto_altra_vettura",
                        placeholder: "Sì/No",
                        mandatory: false
                    },
                    {
                        label: "Marca della Vettura Desiderata",
                        type: "select",
                        id: 'marchio',
                        name: "marca_vettura_desiderata",
                        options: [], // Add more brands as needed
                        placeholder: "Seleziona Marca",
                        master: 'acquisto_altra_vettura',
                        mandatory: false
                    },
                    {
                        label: "Modello della Vettura Desiderata",
                        type: "select",
                        id: 'modello',
                        name: "modello_vettura_desiderata",
                        options: ['Modello: Tutti'], // Populate based on selected Marca or keep it empty to be filled dynamically
                        placeholder: "Seleziona Modello",
                        master: 'acquisto_altra_vettura',
                        mandatory: false
                    },
                    {
                        label: "Descrizione Libera",
                        type: "textarea",
                        name: "descrizione_libera",
                        placeholder: "Aggiungi una descrizione",
                        mandatory: false
                    },
                    {
                        label: "Vuoi aggiungere altre informazioni?",
                        type: "textarea",
                        name: "altre_informazioni",
                        placeholder: "Dettagli aggiuntivi",
                        mandatory: false
                    },
                    {
                        label: "Ho letto e accetto l’informativa sulla privacy",
                        type: "checkbox",
                        name: "informativa_privacy"
                    },
                    {
                        label: "Desidero ricevere comunicazioni su offerte e promozioni future da Auto Vi",
                        type: "checkbox",
                        name: "comunicazioni_promozionali",
                        mandatory: false
                    }
                ]
            },
            {
                title: "Grazie per averci contattati!",
                text: "La tua richiesta è stata presa in carico, un nostro agente ti contatterà al più presto ai recapiti da te forniti."
            },
        ];
    }
});





